/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { zeroPadding, isAfterFourPM } from '@insticator/insticator-ui'; // iui-utils
import {
    CREATE_REPORT,
    SET_REPORT_PROPERTIES,
    RECEIVE_REPORT_DATA,
    RUN_REPORT,
    SET_SAVE_REPORT_PENDING,
    SET_REPORT_SAVED,
    SET_RUN_REPORT_PENDING,
    SET_PROCESSING,
    START_DOWNLOADING_REPORT,
    END_DOWNLOADING_REPORT,
    DISCARD_REPORT_CHANGES
} from 'state/actions/reportsState/selected_report_status';






/* ========== ~~~~~~~~~~ REPORTS STATE > SELECTED REPORT STATUS: REDUCER ~~~~~~~~~~ ========== */
// REDUCER
// used to manipulate application state
// takes an action, checks its type, based on that performs certain functionality, then returns new slice of state
// utilized in "_container" components


//-=-=-=-=-=-=-=-=-=-=-= Default State -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=//
const generateDefaultExpirationDate = () => {
    let today = new Date();
    return `${today.getFullYear()}-${zeroPadding((today.getMonth() + 1), 2)}-${zeroPadding(today.getDate(), 2)}`;
};

const generateDefaultEndDate = () => {
    let today = new Date(new Date() - (isAfterFourPM() ? (1000 * 60 * 60 * 24) : (1000 * 60 * 60 * 24 * 2)));
    return `${today.getFullYear()}-${zeroPadding((today.getMonth() + 1), 2)}-${zeroPadding(today.getDate(), 2)}`;
};

// NOTE: Add this method anywhere the emails are fetched for editing or creating the report settings.
const transpileEmailForm = email => ({value: !!email ? email : '', valid: !!email ? true : null });

const transpileEmailData = (emails) => {
    emails.forEach((val, index) => {
        if(Object.keys(val).indexOf('value') === -1) {
            emails[index] = transpileEmailForm(val);
        }
    });
    return emails;
};

const generateDefaultStartDate = () => {
    let week = new Date(new Date() - (1000 * 60 * 60 * 24 * 5));
    return `${week.getFullYear()}-${zeroPadding((week.getMonth() + 1), 2)}-${zeroPadding(week.getDate(), 2)}`;
};
const tranpileReportData = (data, state) => ({
    accountUUID: !!data.accountUUID ? data.accountUUID : state.accountUUID,
    reportUUID: !!data.reportUUID ? data.reportUUID : state.reportUUID,
    name: !!data.name ? data.name : state.name,
    dateRange: !!data.dateRange ? data.dateRange : state.dateRange,
    dimensions: !!data.dimensions ? data.dimensions: state.dimensions,
    order: [],
    sites: !!data.sites ? data.sites : state.sites,
    devices: !!data.devices ? data.devices : state.devices,
    countries: !!data.countries ? data.countries : state.countries,
    viewType: !!data.viewType ? data.viewType : state.viewType,
    metrics: !!data.metrics ? data.metrics : state.metrics,
    schedule: !!data.schedule ? data.schedule : 'ONCE',
    emails: !!data.emails ? transpileEmailData(data.emails) : transpileEmailData(state.emails),
    customDateRange: data.dateRange === 'CUSTOM' ? data.customDateRange : state.customDateRange,
    endDate: !!data.endDate ? data.endDate : state.endDate,
    selectedReportDataValid: {
        settings: null,
        dimensions: null,
        metrics: null,
        schedule: null,
    }
});

const defaultState = {
    status: {
        saveReportPending: false,
        isReportSaved: false,
        reportChangeDetected: false,
        runReportPending: false,
        processing: false
    },
    reportDownloading: [],
    selectedReportData: {
        accountUUID: "", //"45672smd2"
        reportUUID: null,
        name: "", //"Sample Report name",
        dateRange: "YESTERDAY", //"YESTERDAY | LAST_SEVEN_DAYS | LAST_THIRTY_DAYS | LAST_WEEK | LAST_MONTH | CUSTOM",
        dimensions: ["DATE", "SITE", "DEVICE", "GEO", "AD_UNIT"], //["DATE", "SITE", "DEVICE", "GEO", "AD_UNIT"] this needs to be in specific order for retrieving report preview
        order: [],
        sites: [], //["SITE_UUID_1", "SITE_UUID_2", "EMPTY_IF_ALL_SITES_ARE_CHOSEN"]
        devices: [], //["DESKTOP", "MOBILE", "EMPTY_IF_ALL"]
        countries: [], //["IN", "US", "EMPTY_IF_ALL"]
        viewType: "AGGREGATE", //"BREAKDOWN | AGGREGATE"
        metrics: ["VIDEO_CPM", "VIDEO_IMPRESSION", "VIDEO_REVENUE", "DISPLAY_CPM", "DISPLAY_IMPRESSION", "DISPLAY_REVENUE"], //["VIDEO_CPM", "VIDEO_IMPRESSION", "VIDEO_REVENUE", "DISPLAY_CPM", "DISPLAY_IMPRESSION", "DISPLAY_REVENUE"]
        schedule: 'ONCE', //"DAILY | WEEKLY | MONTHLY | null if Once"
        emails: [], //["email1", "email2"]
        customDateRange: {from: generateDefaultStartDate(), to: generateDefaultEndDate()},
        endDate: generateDefaultExpirationDate(),
        selectedReportDataValid: {
            settings: null,
            dimensions: null,
            metrics: null,
            schedule: null,
        },
    },
    previewReportData: {
        total:{},
        data: []
    }
};

let previousSelectedReportData = {};

const selectedReportStatus = (state = defaultState, action) => {
    let newState = JSON.parse(JSON.stringify(state));
    switch (action.type) {
        case SET_REPORT_PROPERTIES:
            for (let property of Object.keys(action.properties)) {
                newState.selectedReportData[property] = (property === 'emails')? transpileEmailData(action.properties[property]) : action.properties[property];
            }
            newState.status.reportChangeDetected = true;
            newState.status.isReportSaved = false;
            return newState;
        case RECEIVE_REPORT_DATA:
            newState.selectedReportData = tranpileReportData(action.reportData, defaultState.selectedReportData);
            newState.status.isReportSaved = true;
            newState.status.reportChangeDetected = false;
            previousSelectedReportData = JSON.parse(JSON.stringify(newState.selectedReportData));
            return newState;
        case RUN_REPORT:
            newState.previewReportData = action.data;
            return newState;
        case CREATE_REPORT:
            newState.selectedReportData = defaultState.selectedReportData;
            newState.status.isReportSaved = false;
            newState.status.reportChangeDetected = false;
            // previousSelectedReportData = JSON.parse(JSON.stringify(newState.selectedReportData));
            return newState;
        case SET_SAVE_REPORT_PENDING:
            newState.status.saveReportPending = action.status;
            return newState;
        case SET_REPORT_SAVED:
            newState.status.isReportSaved = action.status;
            return newState;
        case SET_RUN_REPORT_PENDING:
            newState.status.runReportPending = action.status;
            return newState;
        case SET_PROCESSING:
            newState.status.processing = action.status;
            return newState;
        case DISCARD_REPORT_CHANGES:
            if (!newState.selectedReportData.accountUUID) return defaultState;
            // selectedReportData is saved when we receive the data from the BE
            newState.selectedReportData = previousSelectedReportData;
            newState.status.isReportSaved = true;
            newState.status.reportChangeDetected = false;
            return newState;
        case START_DOWNLOADING_REPORT:
            newState.reportDownloading.push(action.reportType);
            return newState;
        case END_DOWNLOADING_REPORT:
            newState.reportDownloading.splice(newState.reportDownloading.indexOf(action.reportType), 1);
            return newState;
        default:
            return state;
    }
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default selectedReportStatus;
